import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S34DropdownsSection } from '../components/interactive-sections/S34Dropdowns';
import { getBackgroundColorInput, getPaddingInputs } from '../utils/builderSharedInputs';
import { altBackgroundColorOptions } from '../utils/builderColorOptions';

Builder.registerComponent(S34DropdownsSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S34Dropdowns,
  friendlyName: 'S34 Dropdowns',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Learn More About Our Services and Clinics',
      friendlyName: 'Title',
      required: true,
      helperText: 'The description text displayed below the title',
    },
    {
      name: 'description',
      type: 'string',
      friendlyName: 'Description',
      helperText: 'The description text displayed below the title',
    },
    {
      name: 'showBodyAreas',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Body Area Section',
    },
    {
      name: 'showConditions',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Conditions Section',
    },
    {
      name: 'showLocations',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Locations Section',
    },
    {
      name: 'showResources',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Resources Section',
    },
    ...getBackgroundColorInput({
      defaultValue: 'Turquoise20',
      backgroundColorsList: altBackgroundColorOptions,
    }),
    ...getPaddingInputs()
  ]
}); 